/*** IMPORTS FROM imports-loader ***/
var define = false;

import tagTester from './_tagTester.js';

export default tagTester('RegExp');




//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/isRegExp.js
// module id = 163
// module chunks = 0